module.exports = __webpack_public_path__ + "assets/img/00180.4d60781f.png";